import { render, staticRenderFns } from "./AdministradorComercial.vue?vue&type=template&id=3a20374b&scoped=true&"
import script from "./AdministradorComercial.vue?vue&type=script&lang=js&"
export * from "./AdministradorComercial.vue?vue&type=script&lang=js&"
import style0 from "./AdministradorComercial.vue?vue&type=style&index=0&id=3a20374b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20374b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})
